const RELOAD_MARKER = "steptember:stale-chunk-reload";
const RELOAD_COOLDOWN_MS = 60_000;

interface RecoveryOptions {
  target?: EventTarget;
  storage?: Pick<Storage, "getItem" | "setItem">;
  reload?: () => void;
  now?: () => number;
}

export function installStaleChunkRecovery({
  target = window,
  storage,
  reload = () => window.location.reload(),
  now = Date.now,
}: RecoveryOptions = {}) {
  let fallbackReloadAt: number | null = null;

  const onPreloadError = (event: Event) => {
    const current = now();
    let previous = fallbackReloadAt;
    try {
      const persisted = (storage ?? window.sessionStorage).getItem(RELOAD_MARKER);
      if (persisted !== null) previous = Number(persisted);
    } catch {
      // Some privacy modes disable sessionStorage. The in-memory marker still
      // prevents a reload loop for duplicate events in the current document.
    }

    if (previous !== null
        && Number.isFinite(previous)
        && current - previous < RELOAD_COOLDOWN_MS) {
      return;
    }

    fallbackReloadAt = current;
    try {
      (storage ?? window.sessionStorage).setItem(RELOAD_MARKER, String(current));
    } catch {
      // Reload recovery remains available even when browser storage is blocked.
    }
    event.preventDefault();
    reload();
  };

  target.addEventListener("vite:preloadError", onPreloadError);
  return () => target.removeEventListener("vite:preloadError", onPreloadError);
}
